var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpLoaderFactory } from './shared.module';
import * as Sentry from '@sentry/browser';
import { appVersion, environment } from '../environments/environment';
import { LOCATION_INITIALIZED } from '@angular/common';
import { UserService } from './services/user.service';
import { ObjectUtils } from './utils/object.utils';
import { ReferenceDataService } from './services/reference-data/reference-data.service';
import { WebUtils } from './utils/web.utils';
import { CommonConstant } from './app.constants';
Sentry.init({
    dsn: environment.sentry,
    release: appVersion,
    environment: environment.production ? 'production' : 'development',
    ignoreErrors: [
        /^not found platform setting for account id/,
        /^You must select at least 1 filter to generate a report/,
        /^add_new_campaign_error/,
        /^update_campaign_error/,
        /^Non-Error exception captured with keys: error, headers, message, name, ok/,
        /We’re unable to add your selection to the group. All of the [0-9]+ seats allowed for your account are currently in use./,
        /You are trying to add [0-9]+ influencers to a group, but you only have [0-9]+ slots available./,
        /504 Gateway Timeout/
    ],
    beforeSend: function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var customEvent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        customEvent = event;
                        return [4 /*yield*/, addSwLog(event)];
                    case 1:
                        customEvent = _a.sent();
                        return [2 /*return*/, customEvent];
                }
            });
        });
    }
});
function addSwLog(event) {
    return __awaiter(this, void 0, void 0, function () {
        var swDebuggerLog, swLogContent, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    if (!environment.production) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetch(environment.hostName + "/ngsw/state")];
                case 1:
                    swDebuggerLog = _a.sent();
                    return [4 /*yield*/, swDebuggerLog.text()];
                case 2:
                    swLogContent = _a.sent();
                    if (swLogContent.length > CommonConstant.MAX_LOG_LENGTH) {
                        swLogContent = swLogContent.substring(0, CommonConstant.MAX_LOG_LENGTH);
                    }
                    event.breadcrumbs.push({
                        category: 'sw_log',
                        message: swLogContent
                    });
                    console.log("event.breadcrumbs: " + event.breadcrumbs.length);
                    _a.label = 3;
                case 3: return [2 /*return*/, event];
                case 4:
                    err_1 = _a.sent();
                    return [2 /*return*/, event];
                case 5: return [2 /*return*/];
            }
        });
    });
}
/**
 * define factory which use to load data or configuration when initialize application
 * @param {TranslateService} translate
 * @param {Injector} injector
 * @returns {() => Promise<any>}
 */
export function appInitializerFactory(translate, injector) {
    return function () { return new Promise(function (resolve) {
        var locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
        locationInitialized.then(function () {
            var lang = 'en';
            translate.setDefaultLang(lang);
            translate.use(lang).subscribe(function () {
                resolve(true);
            }, function (err) {
                Sentry.captureException(new Error("Problem with '" + lang + "' language initialization.'"));
            }, function () {
                resolve(null);
            });
        });
    }); };
}
export function getCompanyFactory(injector) {
    return function () {
        return new Promise(function (resolve, reject) {
            if (!localStorage.getItem('user')) {
                resolve();
            }
            else {
                var user_1 = ObjectUtils.parseJSON(localStorage.getItem('user'));
                if (user_1 !== null) {
                    // workaround to prevent cyclic dependency issue.
                    // Refer: https://github.com/angular/angular/issues/18224
                    setTimeout(function () {
                        var userService = injector.get(UserService);
                        var activeAccount = WebUtils.extractActiveAccountFromUrl();
                        userService.loadAccountListByUserTask(user_1, activeAccount)
                            .subscribe({
                            next: resolve,
                            error: resolve
                        });
                    });
                }
            }
        });
    };
}
export function loadReferenceDataFactory(injector) {
    return function () {
        return new Promise(function (resolve, reject) {
            // workaround to prevent cyclic dependency issue.
            // Refer: https://github.com/angular/angular/issues/18224
            setTimeout(function () {
                var referenceService = injector.get(ReferenceDataService);
                referenceService.loadDefinitions().subscribe(function (res) {
                    referenceService.updateDefinitionsData(res.data);
                    resolve();
                }, function (error) {
                    resolve();
                });
            });
        });
    };
}
var ɵ0 = HttpLoaderFactory;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };



// WEBPACK FOOTER //
// ./src/app/app.module.ts.pre-build-optimizer.js